import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import FinancialDocumentRowFormModal from 'src/features/financialDocumentRows/components/forms/FinancialDocumentRowFormModal';
import { useCreateFinancialDocumentRow } from 'src/features/financialDocumentRows/api/useCreateFinancialDocumentRow';
import { financialDocumentRowMessages } from 'src/features/financialDocumentRows/utils/messages';
import { LIST_FINANCIAL_DOCUMENT_ROWS_RESOURCE } from 'src/features/financialDocumentRows/api/useListFinancialDocumentRows';
import { useParams } from 'react-router-dom';
import { FINANCIAL_DOCUMENT_RESOURCE } from 'src/features/financialDocuments/api/useGetFinancialDocument';

interface CreateDocumentRowFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateFinancialDocumentRowFormModal<TData>({ className, semantics }: CreateDocumentRowFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { financialDocumentId = '' } = useParams();

    const { mutate, isPending } = useCreateFinancialDocumentRow({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_FINANCIAL_DOCUMENT_ROWS_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [FINANCIAL_DOCUMENT_RESOURCE] });
            toast({
                title: formatMessage(financialDocumentRowMessages.createFinancialDocumentRowSuccess),
                description: formatMessage(financialDocumentRowMessages.createFinancialDocumentRowSuccessDescription),
            });
        },
    });

    return (
        <FinancialDocumentRowFormModal
            className={className}
            mutate={(values, onSuccess, onError) =>
                mutate({ ...values, financial_document: financialDocumentId }, { onSuccess, onError })
            }
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(financialDocumentRowMessages.addFinancialDocumentRowSubtitle)}
        />
    );
}

export default CreateFinancialDocumentRowFormModal;
